import { Field, Input, Label } from "@headlessui/react"

interface ISingleTextFieldProps {
  label: string
  placeholder?: string
  value: string
  onChange?: (value: string) => void
  disabled?: boolean
  error?: boolean
  maxLength?: number
  minLength?: number
  onFocus?: () => void
  onBlur?: () => void
  onKeyDown?: (e: React.KeyboardEvent) => void
}

export const SingleTextField = (props: ISingleTextFieldProps) => {
  return (
    <Field>
      <Label className={'text-lg'}>{props.label}</Label>
      <div className={'relative'}>
        <Input
          placeholder={props.placeholder}
          autoComplete='off'
          value={props.value}
          onChange={(e) => props.onChange?.(e.target.value)}
          disabled={props.disabled}
          maxLength={props.maxLength}
          onFocus={props.onFocus}
          onBlur={props.onBlur}
          onKeyDown={props.onKeyDown}
          className={
            `mt-3 block w-full appearance-none rounded-lg border-1 px-3 py-3 text-base data-focus:outline-formBorder ${props.error ? 'border-red-500' : 'border-formBorder'
            } ${props.disabled ? 'opacity-50 cursor-not-allowed' : ''}`
          }
        />
      </div>
    </Field>
  )
}
